import { ValidationRules } from "@/models/Validation";
import { t } from "@/plugins/i18n";

export default interface Bank {
  id: number;
  name: string;
  code: string;
  defFilePath: string;
  defFilePathRem: string;
  extCode: string;
  partnerID: number;
  cardCost: number;
  address: string;
  isBankCardPay: boolean;
  isBank: boolean;
  deleted: boolean;
  deleting: boolean;
  inEdit: boolean;
}

export const rules: ValidationRules = {
  code: [
    (v: string) => (!v || v.length <= 2 || v == '-') || t("Bank_AKodNemLehetHosszabbMint"),
  ],
  extCode: [
    (v: string) => (!v || v.length <= 3) || t("Bank_AKulsoKodNemLehetHosszabb"),
  ],
  name: [(v: string) => !!v || t("MegnevezesMegadasaKotelezo")],
};

export const bankDefaultProps: Bank = {
  id: 0,
  name: "",
  code: "",
  defFilePath: "",
  defFilePathRem: "",
  extCode: "",
  partnerID: 0,
  cardCost: 0,
  address: "",
  isBankCardPay: false,
  isBank: true,
  deleted: false,
  deleting: false,
  inEdit: false,
};
